// extracted by mini-css-extract-plugin
module.exports = {"container":"_f47799c","wrapper":"_67a11c4","label":"_5521d2b","issueSelect":"_20ccd27","disable":"_bc69526"};